import React from 'react';

var MobileGameHolder = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: 'pgc-m-game-holder' }, children));
};

export { MobileGameHolder };
